import { PeerConnection } from "@/utils/peer"
import CatalogWorkerUrl from "./catalog.worker?worker&url"
import type { CatalogWorker } from "./catalog.worker"
import { getCatalogFileName, PIXIESET_CATALOG_FILE_NAME } from "./catalog-file-name"

const catalogWorkerUrl = new URL(CatalogWorkerUrl, location.href)
const isPixiesetAuthEnabled = getCatalogFileName() === PIXIESET_CATALOG_FILE_NAME
catalogWorkerUrl.searchParams.set("pixiesetauth", isPixiesetAuthEnabled ? "1" : "0")

export const CatalogConnection = new PeerConnection<CatalogWorker>(catalogWorkerUrl.toString(), {
	label: "Catalog",
})
